<template>
  <h3>Contributions & QAs Document Format Preferences</h3>
  <user-document-preferences />
</template>

<script lang="ts">
import { UserDocumentPreferences } from "referrals/referrals.globals";
import { defineComponent } from "vue";

export default defineComponent({
  components: { UserDocumentPreferences },
});
</script>
